
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/[...category]",
      function () {
        return require("private-next-pages/help/[...category].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help/[...category]"])
      });
    }
  